import { connect } from 'react-redux';
import TambahMasterMapel from '../../views/Settings/TambahMasterMapel.view';
import {
  getClasses, getParamOptionsAcademics, getTeacherOptions,
  getSubjectOptions, getParamOptions, getDayOptions, getClassesOptions, getPeriodsOptions, getPrmLevels,
} from '../../states/thunks/options.thunk';
import {
  getScheduleSubject, updateMasterMapel, saveMasterMapel, listMasterMapel,
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleSaveMasterMapel: (payload, goback) => dispatch(saveMasterMapel(payload, goback)),
    handleListMasterMapel: (payload, goback) => dispatch(listMasterMapel(payload, goback)),
    handleUpdatetMasterMapel: (payload, goback) => dispatch(updateMasterMapel(payload, goback)),
    handleGetScheduleSubject: payload => dispatch(getScheduleSubject(payload)),
    getSubjectOptions: payload => dispatch(getSubjectOptions(payload)),
    getTeacherOptions: payload => dispatch(getTeacherOptions(payload)),
    getDayOptions: payload => dispatch(getDayOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TambahMasterMapel);
